import classnames from "classnames";
export const getButtonClassNames = (variant, isDisabled) => {
    switch (variant) {
        case "default":
            return classnames("h-10 border-transparent text-[#121212]", {
                "bg-[#5B5B13]": isDisabled,
                "bg-yellow active:bg-[#FFFFB2] hover:bg-[#FFFE8B]": !isDisabled,
            });
        case "primary":
            return classnames("h-10 border-transparent", {
                "text-white/50 bg-[#611916]": isDisabled,
                "bg-red text-white hover:bg-[#F5655F] active:bg-[#F78C87]": !isDisabled,
            });
        case "secondary":
            return classnames("h-10 bg-canvas-95", {
                "text-neutral-50 border-yellow/50": isDisabled,
                "hover:bg-canvas-90 text-neutral-0 active:bg-canvas-80 border-yellow hover:border-yellow/80 active:border-yellow/70": !isDisabled,
            });
        case "tertiary":
            return classnames("h-4 bg-transparent hover:bg-transparent border-transparent", {
                "text-[#5B5B13]": isDisabled,
                "hover:text-[#FFFE8B] active:text-[#FFFFB2] text-yellow": !isDisabled,
            });
        case "success":
            return classnames("h-10 text-[#121212] border-transparent bg-green");
    }
};
//# sourceMappingURL=getButtonClassNames.js.map